import React from 'react'
import {
    H2
} from "@blueprintjs/core";

const SessionNotFound = () => {
    return (
        <div className='new-results'>
            <div className="text-center" style={{ marginTop: "15px" }}>
                <H2 id='result'>Session not found</H2>
                <p className='margin-bottom-large'>We couldn't find the session.</p>
            </div>
        </div>
    )
}

export default SessionNotFound
